import { z } from 'zod';
import { isNoLoginEmail } from './no-login-email.js';

const EMAIL = z.email();

/**
 * E-posta biçimi (giriş adı olarak kullanılır; mimari belge §10.3). Hesapsız kişinin yer tutucu
 * alan adı (`@no-login.invalid`, ADR 0131 Ek 1) kullanıcı girdisi olarak kabul edilmez.
 */
export function isValidEmail(value: string): boolean {
  return EMAIL.safeParse(value).success && !isNoLoginEmail(value);
}
